import { mutationOptions } from '@tanstack/react-query';
import { http } from '../common/http-client';
import { getBaseTaskListQueryKey } from '../task/api';
import type { VideoAnalysisTaskDto } from '../task/model';
import type { AnalysisVideoInputDto } from './model';

export const analysisVideo = mutationOptions({
  mutationKey: [...getBaseTaskListQueryKey()],
  mutationFn: async (input: AnalysisVideoInputDto) => {
    const data = await http
      .post('script/video/analysis', {
        json: input,
      })
      .json<VideoAnalysisTaskDto>();

    return data;
  },
});
